import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';
import {
    TranslateHttpLoader,
    TRANSLATE_HTTP_LOADER_CONFIG
} from '@ngx-translate/http-loader';
import { UpgradeModule } from '@angular/upgrade/static';

import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { AppComponent } from './app.component';

import { LoginModule } from '@feature/login/login.module';
import { SettingsModule } from '@feature/settings/settings.module';
import { LeadSearchModule } from '@feature/lead-search/lead-search.module';

import { CoreModule } from '@core/core.module';

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        CoreModule.forRoot(),
        HttpClientModule,
        UpgradeModule,
        UIRouterUpgradeModule,
        LoginModule,
        LeadSearchModule,
        SettingsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: TranslateHttpLoader
            }
        })
    ],
    providers: [
        {
            provide: TRANSLATE_HTTP_LOADER_CONFIG,
            useValue: {
                prefix: '/app/i18n/',
                suffix: '.json'
            }
        }
    ]
})
export class AppModule {
    constructor(private translate: TranslateService) {

        this.translate.addLangs(['en', 'nl', 'fr', 'de', 'es', 'pt-PT', 'pt-BR', 'it']);
        this.translate.setFallbackLang('en');

        // Detect browser language and use it for unauthenticated views
        // Will be overridden by authentication.js if user is logged in
        const browserLanguage = this.detectBrowserLanguage();
        this.translate.use(browserLanguage);
    }

    private detectBrowserLanguage(): string {
        const supportedLanguages: { [key: string]: string } = {
            'en': 'en',
            'nl': 'nl',
            'fr': 'fr',
            'de': 'de',
            'es': 'es',
            'pt': 'pt-PT',
            'pt-pt': 'pt-PT',
            'pt-br': 'pt-BR',
            'it': 'it'
        };

        const navigatorLang = (navigator.language || (navigator.languages && navigator.languages[0])) || 'en';
        const langLower = navigatorLang.toLowerCase();

        // Try exact match first (e.g., 'pt-BR')
        if (supportedLanguages[langLower]) {
            return supportedLanguages[langLower];
        }

        // Try base language (e.g., 'pt' from 'pt-BR')
        const baseLang = langLower.split('-')[0];
        if (supportedLanguages[baseLang]) {
            return supportedLanguages[baseLang];
        }

        // Default to English
        return 'en';
    }

    ngDoBootstrap = () => {};
}
